export const REACT_SCAN_VERSION = "0.2.7";

export const PERFORMANCE_ENABLED_KEY = "performance-monitor";
export const SCRIPT_ID = "react-scan";
export const OVERLAY_ID = "react-scan-root";
export const OVERLAY_CANVAS = "[data-react-scan='true']";
export const STRICT_MODE_ENABLED_KEY = "strict-mode-enabled";
